
import { useHierarchyService } from './useHierarchyService';
import  useRolePermissionServices  from './useRolePermissionServices';

import ProSetupActionMenu from '../components/setup/ProSetupActionMenu';
import ProCensusActionMenu from '../components/census/ProCensusActionMenu';
import ProClient from '../components/census/ProClient';
import ProClientAttendance from '../components/attendance/ProClientAttendance';
import ProClientAllergy from '../components/census/ProClientAllergy';
import ProClientMedication from '../components/census/ProClientMedication';
import ProClientDuration from '../components/census/ProClientDuration';
import ProCensusBedWithActionMenu from '../components/census/ProCensusBedWithActionMenu';

import {Wing, Unit, Dependent,  DependentReservation, Room, UnoccupiedBed} from '../constants/ProIcons'
import { GetAvailableBedCapacityColor } from '../utilities/Helper';
import { IsBefore } from '../utilities/DateHelper';
import _ from "lodash";


let templateData = {data: {}, actions: {}}
const useTreeTemplateServices = ({performAction, activePage = ""})=>{  
    
    const {actions:{SetSelectedTreeNode}} = useHierarchyService();   
    const iconFontSize = 15;
    const {data:{AttendanceRoles, SetupRoles}} = useRolePermissionServices();
   
//#region GENERIC
const TreeNodeTemplate = (node, column)=> {       
    let colValue;
    switch(node.type){
        case "LOCATION":
            colValue =  <i className ="fas fa-map-marker-alt" aria-hidden="true" style={{ color: '#384C7E', fontSize: iconFontSize }}>               
                <span className='tree-node-location'>{node.data.name}                   
                </span>
                </i>    
            break;
        case "BUILDING":
            colValue =  <i className ="fas fa-home-lg-alt" aria-hidden="true" style={{ color: '#384C7E', fontSize: iconFontSize}}>               
                <span className='tree-node-building' >{node.data.name}
                    {!_.get(node, "active") && <span  className='tree-node-inactive'> - Inactive</span> }
                </span>
                </i>    
            break;
        case "FLOOR":
            colValue =  <i className ="fas fa-layer-group" aria-hidden="true" style={{ color: '#384C7E', fontSize: iconFontSize }}>               
                <span className='tree-node'>{node.data.name}
                    {!_.get(node, "active") && <span  className='tree-node-inactive'> - Inactive</span> }   
                </span>
                </i>    
        
            break;  
        case "UNIT":
            colValue = <i className ="fas" aria-hidden="true" style={{ color: '#384C7E', fontSize: iconFontSize }}>
                  <div className='icon-display'>
                  <div><Unit/></div>
                    <span className='tree-node-svg-unit'>{node.data.name}
                        {!_.get(node, "active") && <span  className='tree-node-inactive'> - Inactive</span> }
                    </span>
                </div>
            </i>    
            break;
        case "WING":
            colValue = <i className ="fas" aria-hidden="true" style={{ color:  '#384C7E', fontSize: iconFontSize}}>
                <div className='icon-display'>
                    <div><Wing/></div>
                    <span className='tree-node-svg'>{node.data.name}
                        {!_.get(node, "active") && <span  className='tree-node-inactive'> - Inactive</span> }
                    </span>
                </div>
            </i> 
            break;           
        case "ROOM":
            colValue =  <i className ="fas" aria-hidden="true" style={{ color: '#384C7E', fontSize: iconFontSize }}>   
                           <div className='icon-display'>
                               <div><Room/> </div>            
                                <span className='tree-node-svg'>{node.data.name}
                                    {!_.get(node, "active") && <span  className='tree-node-inactive'> - Inactive</span> }
                                </span>
                            </div> 
                        </i>    
            break;
        case "BED":
            var data = _.get(node.data, "assignments")?_.filter(node.data.assignments, (a)=> a.latestAssignment): null;
            if (!(_.isNull(data) || (_.get(data, "length") === 0)) && (data &&_.isEqual(data[0].occupancyStatus, "OCCUPIED")))
            {  
                colValue = _.isEqual(activePage, "CENSUS")?<ProCensusBedWithActionMenu node={node} performAction={performAction}/> : <i className ="fas fa-bed" aria-hidden="true" style={{ color: '#579800', fontSize: iconFontSize }}>               
                        <span className='tree-node'>{node.label}
                        {!_.get(node, "active") && <span  className='tree-node-inactive'> - Inactive</span> }</span>
                        </i>  
            }else{
                colValue = _.isEqual(activePage, "CENSUS")?<ProCensusBedWithActionMenu node={node} performAction={performAction} isEmpty/> : <i className ="fas" aria-hidden="true" style={{ color: '#579800', fontSize: iconFontSize }}>   
                           <div className='icon-display'>
                               <div><UnoccupiedBed/> </div>            
                                <span className='tree-node-svg-unoccupied'>{node.data.name}
                                    {!_.get(node, "active") && <span className='tree-node-inactive'> - Inactive</span> }
                                </span>
                            </div> 
                        </i>    
            }          
            break;
        default:
            colValue = <i className ="fas" aria-hidden="true"><span className='tree-node'>{node.data.name}</span></i>
            break    
    }
    return colValue;  
}

const OnTreeNodeSelect = (e)=>{       
        SetSelectedTreeNode(e.node); // Set globally
}

//#endregion

//#region  SETUP 
 const SetupNodeActionTemplate = (node, column)=>{
    if(node.type !== "LOCATION" && SetupRoles.canModify)
        return <ProSetupActionMenu performAction={performAction}/>
    else{
        return <span className='tree-node'>{_.get(node.data, "action") || ""}</span>         
    }  

}

const SetupBedStatusTemplate = (node, column)=> {  
    if(node.type === "BED")
    {    const data = _.get(node.data, "assignments")?_.filter(node.data.assignments, (a)=> a.latestAssignment)[0]: node.data;   
        if(_.get(data, "occupancyStatus") === "OCCUPIED"){
            if(_.get(data.occupantType, "code") === "CLIENT"){
            return <i className ="fa fa-user" aria-hidden="true" style={{ color: '#34436d', fontSize: iconFontSize, position: 'relative' }}>               
                <span className='tree-node' style={{position: 'relative'}}>{`${data.occupancyStatus}`}</span>                
            </i> 
            }else{
                return <i className ="fas" aria-hidden="true" style={{ color: '#34436d', fontSize: iconFontSize, position: 'relative' }}> 
                <Dependent/>              
                <span className='tree-node' style={{position: 'relative', top: "-1px"}}>{`${data.occupancyStatus}`}</span>                
            </i> 
            }
        }
        else if(_.get(data, "occupancyStatus") === "UNOCCUPIED" && _.get(data, "reservationStatus") === "RESERVED")
            if(_.get(data.occupantType, "code") === "CLIENT"){
                return <i className ="fal fa-user" aria-hidden="true" style={{ color: '#34436d', fontSize: iconFontSize, position: 'relative' }}>               
                    <span className='tree-node' style={{position: 'relative'}}>{`${data.reservationStatus}`} </span>
                </i> 
            }else{
                return <i className ="fas" aria-hidden="true" style={{ color: '#34436d', fontSize: iconFontSize, position: 'relative' }}> 
                <DependentReservation/>              
                <span className='tree-node' style={{position: 'relative', top: "-1px"}}>{`${data.reservationStatus}`} </span>
            </i> 
            }
        else
         return  <span className='tree-node' style={{position: 'relative'}}> </span>
       
    }   
}

const SetupTableConfig = [{field: "name", actionTemplate:TreeNodeTemplate, expander: true, style:{}}
                         ,{field: "currentStatus", actionTemplate:SetupBedStatusTemplate, expander: false, style:{textAlign:"left", width:"200px"}}
                         ,{field: "action", actionTemplate:SetupNodeActionTemplate, expander: false, style:{textAlign:"right"}}]

//#endregion

//#region CENSUS
 const CensusClientTemplate = (node, column)=> {  
    if(node.type === "BED" && _.get(node.data, "assignments"))  {
        const activeAssignment = _.find(node.data.assignments, function(o) { return o.latestAssignment; }) 
            return <div className="p-d-flex p-flex-column p-jc-between">
                {(_.isEmpty(activeAssignment) || (activeAssignment && (IsBefore(activeAssignment.endDate) && !_.isEqual(_.get(activeAssignment, "reservationStatus"), "RESERVED")) )) && <div className="p-mb-5"> </div>}
                {node.data.assignments.map((assignment, index)=>{                                
                   return <div key={index} className={_.gt(node.data.assignments.length, 1) ?_.isEqual(index+1, node.data.assignments.length)?"p-mb" :"p-mb-3":"p-mb"}>
                       <ProClient key={index} data={assignment}/> </div>                
               })} 
            </div>
    } 
 }

const  CensusBedActionTemplate = (node, column)=> {  
    if(node.type === "BED" && _.get(node, "active")){        
        if(_.get(node.data, "assignments")){
            const activeAssignment = _.find(node.data.assignments, function(o) { return o.latestAssignment; })
            const hasMultipleActiveAssignment = _.gt(_.get(_.filter(node.data.assignments, (a)=> a.latestAssignment), "length"), 1) || (activeAssignment && IsBefore(activeAssignment?.endDate) && !_.isEqual(_.get(activeAssignment, "currentStatus"), "RESERVED"))
           
            return  <div>
                        {(_.isEmpty(activeAssignment) || (activeAssignment && (IsBefore(activeAssignment.endDate) && !_.isEqual(_.get(activeAssignment, "currentStatus"), "RESERVED")) )) && <div className="p-mb-3"><ProCensusActionMenu  performAction={performAction} multipleActive = {hasMultipleActiveAssignment}/> </div>}
                        <div className="p-d-flex p-flex-column p-jc-between">{
                        node.data.assignments.map((assignment, index)=>{
                        return <div key={index} className={_.gt(node.data.assignments.length, 1)?_.isEqual(index+1, node.data.assignments.length)?"p-mb" :"p-mb-3":"p-mb"}>
                         <ProCensusActionMenu key={index}  data={assignment}  performAction={performAction} multipleActive = {hasMultipleActiveAssignment}  />  
                         </div>             
                    })} </div>
                </div> 
        }
        else{           
            return <div className={(_.gt(_.get(node.data.assignments,"length"), 1))?"p-mb-3":"p-mb"}>
             <ProCensusActionMenu  performAction={performAction}/> 
             </div>
        }
    }
   
    else{         
           return  <span style={{color:`${GetAvailableBedCapacityColor(node)}`}}>{_.get(node.data, "action")  || ""}</span>        
    }  
}

const  ClientHasClientAllergy = (node, column)=> {  
    if(_.get(node.data, "assignments")){
        const activeAssignment = _.find(node.data.assignments, function(o) { return o.latestAssignment; })
        return  <div className="p-d-flex p-flex-column p-jc-between">
                {(_.isEmpty(activeAssignment) || (activeAssignment && (IsBefore(activeAssignment.endDate) && !_.isEqual(_.get(activeAssignment, "reservationStatus"), "RESERVED")) )) && <div className="p-mb-5"> </div>}
                {node.data.assignments.map((assignment, index)=>{
                    return <div key={index}><ProClientAllergy index={index} assignment={assignment} performAction={performAction} totalAssignments={node.data.assignments.length}/></div>
                })} 
            </div> 
    }
}
const  ClientHasClientMedications = (node, column)=> {     
    if(_.get(node.data, "assignments")){
        const activeAssignment = _.find(node.data.assignments, function(o) { return o.latestAssignment; })
        return  <div className="p-d-flex p-flex-column p-jc-between">
                {(_.isEmpty(activeAssignment) || (activeAssignment && (IsBefore(activeAssignment.endDate) && !_.isEqual(_.get(activeAssignment, "reservationStatus"), "RESERVED")) )) && <div className="p-mb-5"> </div>}
                {node.data.assignments.map((assignment, index)=>{
                   return <div key={index}><ProClientMedication id={index} assignment={assignment} performAction={performAction} totalAssignments={node.data.assignments.length}/> </div>   
                })} 
            </div>         
    }  
}

const ClientStayDuration = (node, column)=>{
    if(_.get(node.data, "assignments")){       
        const activeAssignment = _.find(node.data.assignments, function(o) { return o.latestAssignment; })
        return  <div className="p-d-flex p-flex-column p-jc-between">
                {(_.isEmpty(activeAssignment) || (activeAssignment && (IsBefore(activeAssignment.endDate) && !_.isEqual(_.get(activeAssignment, "reservationStatus"), "RESERVED")) )) && <div className="p-mb-5"> </div>}
                {node.data.assignments.map((assignment, index)=>{
                   return <div key={index}><ProClientDuration id={index} assignment={assignment} performAction={performAction} totalAssignments={node.data.assignments.length}/> </div>   
                })} 
            </div>         
    }  
}


const CensusTableConfig = [{field: "name", actionTemplate:TreeNodeTemplate, expander: true, style:{}}
                          ,{field: "hasClientMedications", actionTemplate:ClientHasClientMedications, expander: false, style:{textAlign:"center", width:"30px"}}
                          ,{field: "hasClientAllergy", actionTemplate:ClientHasClientAllergy, expander: false, style:{textAlign:"center", width:"30px"}}
                          ,{field: "clientDisplayName", actionTemplate:CensusClientTemplate, expander: false, style:{textAlign:"left"}}
                          ,{field: "duration", actionTemplate:ClientStayDuration, expander:false, style:{textAlign:'left', width:"15%"}}
                          ,{field: "action", actionTemplate:CensusBedActionTemplate, expander: false, style:{textAlign:"right", width:"15%"}}]



//#endregion

//#region Attendance
const AttendanceClientTemplate = (node, column)=> {  
    if(node.type === "BED" && _.get(node.data, "assignments")){
        const activeAssignment = _.find(node.data.assignments, function(o) { return o.latestAssignment; })        
            return <div className="p-d-flex p-flex-column p-jc-between">
                 {_.isEmpty(activeAssignment) && <div className="p-mb-2"> </div>}
                {node.data.assignments.map((assignment, index)=>{
                   return <div key={index} className={_.gt(node.data.assignments.length, 1) ?_.isEqual(index+1, node.data.assignments.length)?"p-mb" :"p-mb-4":"p-mb"}><ProClient key={index} data={assignment}/> </div>               
               })} 
            </div> 
    }
 }

 
const AttendanceNodeActionTemplate = (node, column)=>{    
    if(node.type === "BED" && _.get(node.data, "assignments") 
        && _.get(node.data.assignments, "length") > 0 && node.data.assignments[0].occupancyStatus === "OCCUPIED"
        && _.get(node.data.assignments[0].occupantType, "code") === "CLIENT" && AttendanceRoles.canMarkAttendance) 
    { 
      return <div className="p-d-flex p-flex-column p-jc-between">
           {node.data.assignments.map((assignment, index)=>{
              let attIndex = _.findIndex(node.data.attendance, (c)=>_.isEqual(c.clientId, assignment.client.id))
              if(_.gt(attIndex, -1))
                return <div key={index} className={_.gt(node.data.assignments.length, 1)?"p-mb-2":"p-mb"}> 
                        <ProClientAttendance bed={node} attendance={node.data.attendance[attIndex]} client={assignment.client}/> 
                </div>               
            })} 
           
        </div>
      
    }

    return <div className='tree-node' style={{color:`${GetAvailableBedCapacityColor(node)}`}}>{_.get(node.data, "action")  || ""}</div> 

}

const AttendanceTableConfig = [{field: "name", actionTemplate:TreeNodeTemplate, expander: true}
                         ,{field: "clientDisplayName", actionTemplate:AttendanceClientTemplate, expander: false, style:{textAlign:"left"}}
                         ,{field: "action", actionTemplate:AttendanceNodeActionTemplate, expander: false, style:{textAlign:"right"}}]
//#endregion
    templateData = {data: {SetupTableConfig, CensusTableConfig, AttendanceTableConfig}, actions:{ OnTreeNodeSelect}}

   
    return templateData
}

export default useTreeTemplateServices 